import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';

interface Props {
  open: boolean;
  company: string;
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

const PermanentOffReasonModal: React.FC<Props> = ({ open, company, isSubmitting, onClose, onConfirm }) => {
  const [reason, setReason] = useState('');
  const trimmed = reason.trim();

  const handleClose = () => {
    setReason('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Permanently disable collections</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          This permanently stops all collection emails for {company}. A reason is required and will be recorded.
        </DialogContentText>
        <TextField
          label="Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          multiline
          minRows={2}
          fullWidth
          autoFocus
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button
          color="error"
          variant="contained"
          disabled={!trimmed || isSubmitting}
          onClick={() => {
            const confirmed = trimmed;
            setReason('');
            onConfirm(confirmed);
          }}
        >
          Permanently disable
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PermanentOffReasonModal;
